import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { environment } from '~environments/environment';

@Directive({
  selector: '[saOnlyEnv]',
})
export class OnlyEnvDirective {
  private hasView = false;

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

  @Input() set saOnlyEnv(environments: string[]) {
    const isEnv = environments.includes(environment.featureFlagKey);
    if (isEnv && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!isEnv && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
